import LogoDisplay from './LogoDisplay';

export default LogoDisplay;
